import { cleanEmail } from "@/lib/email-rule";

/**
 * A party key or alias as it leaves the import: the cell an import row uses
 * to name its main guest (`mainGuest`) or itself (`partyAlias`).
 *
 * A key may be a 24-hex id, a booking code, a label — or the main guest's
 * E-MAIL ADDRESS. The e-mail column is uploaded cleaned (`parseEmail`, plan
 * "Saubere Eingaben": the rule's invisible code points gone), so a key that
 * is an address has to be cleaned the same way, or a sheet whose address
 * carries a zero-width space in BOTH columns stops linking: the stored
 * address no longer equals the key that points at it.
 *
 * Anything without an "@" is not an address and keeps today's treatment — a
 * plain trim. Used for both columns, so a key and the alias it names can
 * never be normalised differently.
 */
export function partyKeyValue(raw: string): string {
  return raw.includes("@") ? cleanEmail(raw) : raw.trim();
}
